<template>
  <ValidationProvider tag="div" :rules="rules" :name="name" :vid="vid" v-slot="{ errors, validate }" :mode="mode">
    <div ref="select">
      <VueSelect
        v-model="currentValue"
        v-bind="$attrs"
        :class="[
          inputClass,
          {
            'is-invalid': errors.length,
            'is-empty': currentValue ? false : true,
          },
        ]"
        :appendToBody="true"
        @search:blur="validate"
      >
        <template #no-options="{ search }">
          <template v-if="search">
            Sin opciones para <mark>{{ search }}</mark>
          </template>
          <template v-else>
            No hay opciones
          </template>
        </template>
        <template #open-indicator="{ attributes }">
          <span v-bind="attributes" class="fa fa-angle-down"></span>
        </template>
        <template #spinner="{ loading }">
          <!-- <div style="border-left-color: rgba(88, 151, 251, 0.71)" class="vs__spinner">
            The .vs__spinner class will hide the text for me.
          </div> -->
          <i v-if="loading" class="fa fa-fw fa-circle-notch fa-spin text-primary"></i>
        </template>
      </VueSelect>
    </div>
    <template v-if="errors">
      <b-tooltip v-if="errorMode == 'tooltip'" :target="() => $refs['select']" :title="errors.length ? errors[0] : null" variant="danger" noninteractive placement="top" boundary="window"></b-tooltip>
      <div v-else class="text-danger">
        {{ errors[0] }}
      </div>
    </template>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import VueSelect from "vue-select";
import { BTooltip } from "bootstrap-vue";
export default {
  name: "InputSelect",
  components: {
    ValidationProvider,
    VueSelect,
    BTooltip,
  },
  props: {
    value: {
      type: null,
      default: "",
    },
    rules: {
      type: [String, Object],
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    vid: {
      type: String,
      default: undefined,
    },
    mode: {
      type: String,
      default: "eager",
    },
    inputClass: {
      type: String,
      default: "form-control-sm",
    },
    errorMode: {
      type: String,
      default: "normal",
    },
  },
  data() {
    return {
      currentValue: this.value,
    };
  },
  watch: {
    currentValue(val) {
      this.$emit("input", val);
    },
    value(val) {
      this.currentValue = val;
    },
  },
};
</script>
